<template>
  <el-cascader 
    ref="cascader"
    :value="checkedValue"
    :options="options" 
    :props="props"
    placeholder="请选择答案"
    @input="handleChange"
    clearable
    ></el-cascader>
</template>

<script>
export default {
  props: {
    value: Array,
    items: Array,
    depth: Number,
    strictly: Boolean,
  },
  data () {
    let vm = this
    return {
      initTimeoutId: null,
      checkedValue: [],
      options: [],
      props: {
        multiple: false, 
        checkStrictly: !!this.strictly,
        lazy: true,
        lazyLoad (node, resolve) {
          if (node.level > 0 && node.data && node.data.children.length === 0) {
            let items = vm.buildOptions(node.level + 1, node.data.path)
            resolve(items)
          } else {
            resolve([])
          }
        }
      },
      oldDepth: null
    }
  },
  watch: {
    value (val) {
      if (val !== this.checkedValue) {
        this.initializeOptions();
      }
    },
    items () {
      this.initializeOptions()
    },
    depth (d) {
      d === this.oldDepth || this.initializeOptions()
    },
    strictly () {
      this.props.checkStrictly = !!this.strictly
    }
  },
  mounted () {
    this.initializeOptions()
  },
  computed: {
    level () {
      if (this.depth === undefined || this.depth === null) {
        return this.items.length
      }
      return Math.min(this.depth || 1, this.items.length)
    }
  },
  methods: {
    initializeOptions() {
      if (this.initTimeoutId) return
      this.initTimeoutId = window.setTimeout(() => {
        this.initOptions()
        this.initTimeoutId = null
      }, 10)
    },
    initOptions () {
      this.$refs.cascader.panel.activePath = []
      let node = { children: this.buildOptions(1, '') }
      if (this.value && this.value.length > 0) {
        const valMax = Math.max(...this.value);
        const len = Math.min(valMax + 1, this.items.length);
        const values = this.value.filter(n => n < len);
        for(let i = 1; i < len; i++) {
          this.expandNode(node, values.slice(0, i))
        }
      }
      this.oldDepth = this.depth
      this.options = node.children
      this.checkedValue = this.value
      this.$refs.cascader.checkedValue = this.value
    },
    expandNode (node, val) {
      if (this.level <= val.length || !val.length) return
      val.forEach((v, i) => {
        node = node.children.find(n => n.value === v)
      })
      if (!node.children || node.children.length === 0) {
        node.children = this.buildOptions(val.length + 1, node.path)
      }
    },
    buildOptions (level, base) {
      let opts = []
      let len = this.items.length
      let path = '/' + base + '/'
      if (base) base += '/'
      for (let i = 0; i < len; i++) {
        if (path.indexOf('/' + i + '/') < 0) {
          let val = this.items[i]
          opts.push({
            value: i,
            label: i + 1 + '.' + (val.text ? val.text.substring(0, 15) : ''),
            path: base + i,
            leaf: true
          })
        }
      }
      if (this.level > level) {
        opts.forEach(n => {
          n.children = []
          n.leaf = false
        })
      }
      return opts
    },
    handleChange (val) {
      this.checkedValue = val
      this.$emit('input', val)
    }
  }
}
</script>
